import { Stack, Typography } from '@mui/material';
import { useRef } from 'react';
import { IContainer } from '../@types/animate';
import { Props } from '../@types/title';

// -------------------------------------------------------------------

export const organization: string = ' | Pafesan Toldos e Fachadas';

// -------------------------------------------------------------------

export function Title({ nome }: Props) {
  return (
    <Typography variant="h4" align="center" mt={2} mb={2}>
      {nome}
    </Typography>
  );
}

// -------------------------------------------------------------------

export function Container({ children }: IContainer) {
  return (
    <Stack m="5%" mt="30px" mb="30px" style={{ overflow: 'hidden' }}>
      {children}
    </Stack>
  );
}

// -------------------------------------------------------------------

export const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
  if (ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
};

// -------------------------------------------------------------------

export const GlobalRefs = () => {
  const contactRef = useRef<HTMLDivElement>(null);
  const differencesRef = useRef<HTMLDivElement>(null);
  const adsRef = useRef<HTMLDivElement>(null);
  const coverRef = useRef<HTMLDivElement>(null);

  return {
    contactRef,
    adsRef,
    coverRef,
    differencesRef,
  };
};
